/* eslint-disable  no-unneeded-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import './button.scss';
import clsx from 'clsx';
import useTranslation from '../../../utils/translation-utils';
import Icon, { IconColors, IconSizes, IconTypes } from '../icon';

const ButtonTypes = {
  PRIMARY: 'btn-primary',
  SECONDARY: 'btn-secondary',
  TERTIARY: 'btn-tertiary',
  LINK: 'btn-link',
  DESTRUCTIVE: 'btn-destructive',
};

const ButtonSizes = {
  X_SMALL: 'size-xs',
  SMALL: 'size-s',
  MEDIUM: 'size-m',
};

const Button = React.forwardRef(({
  label, type, icon, size, disabled, onClick, className, customIconColor,
}, ref) => {
  const [getTranslation] = useTranslation();
  const classNames = clsx('btn-cont', type, size, className, { 'btn-less-pad': !label });

  const getIcon = () => {
    if (icon) {
      let iconColor = IconColors.LIGHT;

      switch (type) {
        case ButtonTypes.PRIMARY:
        case ButtonTypes.DESTRUCTIVE:
          break;
        case ButtonTypes.LINK:
          iconColor = IconColors.PRIMARY;
          break;
        case ButtonTypes.SECONDARY:
        default:
          iconColor = IconColors.DARK;
          break;
      }
      return (
        <Icon
          type={icon}
          size={IconSizes.MEDIUM}
          color={customIconColor ? customIconColor : iconColor}
        />
      );
    }
    return null;
  };

  const getText = () => {
    if (label) {
      return <span className="btn-text ellipsis">{getTranslation(label)}</span>;
    }
    return null;
  };

  return (
    <button
      type="button"
      className={classNames}
      disabled={disabled}
      onClick={() => onClick()}
      ref={ref}
    >
      <div className="btn-content">
        {getIcon()}
        {getText()}
      </div>
    </button>
  );
});

Button.propTypes = {
  label: PropTypes.string,
  type: PropTypes.oneOf(Object.values(ButtonTypes)),
  size: PropTypes.oneOf(Object.values(ButtonSizes)),
  icon: PropTypes.oneOf(Object.values(IconTypes)),
  customIconColor: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

Button.defaultProps = {
  label: '',
  type: ButtonTypes.PRIMARY,
  size: ButtonSizes.MEDIUM,
  customIconColor: IconColors.PRIMARY,
  icon: null,
  className: '',
  disabled: false,
  onClick: () => {},
};

export {
  Button as default,
  ButtonTypes,
  ButtonSizes,
};
